import { useContext } from "react";
import { OnboardingContext } from "../components/onboarding/OnboardingProvider";

export const useOnboarding = () => {
  const value = useContext(OnboardingContext);
  if (!value)
    throw new Error("useOnboarding must be used within OnboardingProvider.");
  return value;
};
